<template>
	<div>
		<div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>

		<section>
			<div id="spearhead">
				<div v-if="protocol || personContact.name || personContact.phone || queue" class="d-flex">
					<div class="spearhead-element">
						<span><i class="fas fa-clipboard"></i><b>Protocolo</b></span>
						<p v-if="protocol">{{ protocol }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-user"></i><b>Cliente</b></span>
						<p v-if="personContact.name">{{ personContact.name }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-phone"></i><b>Telefone</b></span>
						<p v-if="personContact.phone">{{ personContact.phone }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
						<p v-if="queue">{{ queue }}</p>
						<p v-else>----------</p>
					</div>

					<div class="spearhead-element" style="align-self: center;">
						<div v-if="id_crm">
							<a v-if="id_crm.includes('-')" style="color: black; font-weight: bold;"
								:href="'https://wakeme.crmeducacional.com/Lead/Editar/' + id_crm" target="_blank"
								rel="noopener noreferrer"><i class="fas fa-link"></i> Acessar CRM</a>

							<div v-else>
								<span><i class="fas fa-paperclip"></i><b>ID CRM</b></span>
								<p>{{ id_crm }}</p>
							</div>
						</div>
						<span v-else>SEM CADASTRO NO CRM</span>
					</div>

					<div class="spearhead-element">
						<span><i class="fas fa-clock"></i><b>Fim da Sessão</b></span>
						<p v-if="session">{{ formatSessionDate(session) }}</p>
						<p v-else>----------</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			interval: '',
			time: '',
			timeFormat: '',
			protocol: '',
			session: '',
			contactCrm: [],
			id_crm: '',
			contact: {
				name: "",
				phone: "",
				consultor_id: null,
				consultor: null,
			},
			personContact: {
				'name': '',
				'phone': '',
			},
			queue: ''
		}
	},
	methods: {
		formatCpf(cpf) {
			try {
				cpf = cpf.replace(/[^\d]/g, "");
				return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			} catch (e) {
				return cpf;
			}
		},
		formatPersonData() {
			try {
				this.person.fullName = this.person.fullName.trim();
			} catch (e) {
				console.error('Cliente sem nome');
			}

			return `<b>Nome:</b> ${this.person.fullName} <b>Idade:</b> ${this.person.age} <b>Data de Nascimento:</b> ${this.person.birthday} <b>CPF:</b> ${this.formatCpf(this.person.CPF)}`;
		},
		formatPersonContact() {
			return `<b>Numero:</b> ${this.personContact.phone}  <b>Protocolo:</b> ${this.protocol}`;
		},
		formathealthInssurance() {
			return `<b>Convenio:</b> ${this.healthInssurance.name} - <b>Registro:</b> ${this.healthInssurance.id}`;
		},
		formatAddress() {
			return `${this.ende.address}, ${this.ende.num}, ${this.ende.city} - ${this.ende.CEP}`;
		},
		insertNine(phone) {
			return phone.length === 10 ? phone.replace(/^(\d{2})(\d{4})(\d{4})$/, '$1$29$2$3') : phone;
		},
		removeNine(phone) {
			// Remove o 9 após o DDD
			return phone.length === 11 ? phone.replace(/^(\d{2})9(\d{4})(\d{4})$/, '$1$2$3') : phone;
		},
		async setClientData(client) {
			if (!Object.keys(client).length) return
			let clientName = '';
			let phoneEdited = '';
			this.protocol = "";
			this.queue = "";
			this.id_crm = client.id_crm;
			this.session = client.sessionDate || new Date().toISOString();

			if (client?.phone) {
				const basePhoneWithNine = this.getPhone.replace(/^(\d{2})(\d{4})(\d{4})$/, '$19$2$3');

				let datePhone;

				datePhone = await axios(`/share-client-cnpj?share=${this.getPhone}`);

				if (!(datePhone.data && datePhone.data.length > 0)) {
					datePhone = await axios(`/share-client-cnpj?share=${basePhoneWithNine}`);
				}

				if (!(datePhone.data && datePhone.data.length > 0)) {
					// Atualiza os dados do contato localmente
					this.contact.name = client.name;
					this.contact.phone = this.getPhone;
					this.contact.consultor_id = user.getCrmID();
					this.contact.consultor = user.getExtension();
					axios.post("dialer/saveContact", this.contact);
				}

			}

			if (this.getPhone) {
				if (client.type == 'webchat') {
					phoneEdited = this.formTelefone(client.phone);
				} else {
					let phoneArr = '';
					if (client.phone) {
						phoneArr = client.phone.split('@');
					} else {
						phoneArr = client.client_id.split('@');
					}

					phoneEdited = this.formTelefone(phoneArr[0]);
				}

				let phoneWithoutDoublePlus = phoneEdited;
				phoneWithoutDoublePlus = phoneEdited.replace("+", "");
				clientName = await axios(`/share-client-cnpj?share=${phoneWithoutDoublePlus}`)
					.then(({ data }) => {
						if (data.length > 0) {
							return data[0].name;
						} else {
							return this.formTelefone(phoneWithoutDoublePlus, true);
						}
					});

				this.personContact = {
					'name': client.name || clientName,
					'phone': phoneEdited,
				}

				if (client.queue == 'entrante') {
					this.queue = 'Atendimento Ativo';

				} else {
					this.queue = client.queue;
				}

				this.protocol = client.protocol;
				this.id_crm = client.id_crm;
				return;
			}

			let phoneWithoutDoublePlus = client.phone;
			if (client.phone && client.type == 'phone') {
				phoneWithoutDoublePlus = client.phone.replace("+", "");
				this.protocol = client.protocol;
				this.queue = client.queue;
				this.id_crm = client.id_crm;
				clientName = await axios(`/share-client-cnpj?share=${phoneWithoutDoublePlus}`)
					.then(({ data }) => {
						if (data.length > 0) {
							return data[0].name;
						} else {
							return this.formTelefone(phoneWithoutDoublePlus, true);
						}
					});
				this.personContact = {
					'name': clientName ?? client.name,
					'phone': this.formTelefone(phoneWithoutDoublePlus, true),
				}
			}
		},
		formTelefone(tel, typePhone = false) {
			if (typePhone) return tel;
			if (tel.substr(0, 2) != '55') return `+${tel}`;

			if ((tel.length == 10) || (tel.length == 11)) {
				const v1 = tel.replace(/\D/g, "");
				const v2 = v1.replace(/^(\d{2})(\d)/g, "($1) $2");
				const v3 = v2.replace(/(\d)(\d{4})$/, "$1-$2");

				return v3;
			}
			tel = tel.replace(/\D/g, "")
			tel = tel.replace(/^(\d)/, "+$1")
			tel = tel.replace(/(.{3})(\d)/, "$1($2")
			tel = tel.replace(/(.{6})(\d)/, "$1)$2")
			if (tel.length == 12) {
				tel = tel.replace(/(.{1})$/, "-$1")
			} else if (tel.length == 13) {
				tel = tel.replace(/(.{2})$/, "-$1")
			} else if (tel.length == 14) {
				tel = tel.replace(/(.{3})$/, "-$1")
			} else if (tel.length == 15) {
				tel = tel.replace(/(.{4})$/, "-$1")
			} else if (tel.length > 15) {
				tel = tel.replace(/(.{4})$/, "-$1")
			}
			tel = tel.replace("(", " (");
			tel = tel.replace(")", ") ");

			return tel;
		},
		formatSessionDate(date) {
			if (!date) return '';
			return window.moment(date).add(1, 'days').format('DD/MM/YYYY HH:mm:ss');
		},
		async saveOldCRM(dados) {
			try {
				const externalApiData = {
					nome: dados.name,
					telefonePrincipal: dados.getPhone,
					evento: { tipo: "676" },
					origem: "191",
					token: "b0ea1b205d3356fe72443897d43e4bf4"
				};

				const { data } = await fetch("https://crmgrupoideal.apprubeus.com.br/api/Contato/cadastro", {
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify(externalApiData)
				});

				if (!data?.dados) return null;
				return data.dados;
			} catch (error) {
				console.error("Erro ao enviar dados para a API externa:", error);
				return null;
			}
		}
	},
	computed: {
		...mapGetters(['isReconnect', 'getDataConnectLine', 'getPhone', 'getDataLog'])
	},
	watch: {
		getDataConnectLine(val) {
			localStorage.setItem("clienteAtual", JSON.stringify(val));
			this.hasData = !!Object.keys(val).length;
			this.setClientData(val);

			if (Object.keys(val).length === 0) {
				const viewedNotifications = JSON.parse(localStorage.getItem("viewedNotifications")) || {};
				Object.keys(viewedNotifications).forEach((key) => {
					if (key === this.personContact.name) {
						delete viewedNotifications[key];
					}
				});
				localStorage.setItem("viewedNotifications", JSON.stringify(viewedNotifications));

				this.personContact = {
					name: '',
					phone: ''
				};

				this.protocol = '';
				this.id_crm = '';
				this.queue = '';
				this.session = '';
			} else {
				let viewedNotifications = JSON.parse(localStorage.getItem("viewedNotifications"));
				if (!viewedNotifications) {
					viewedNotifications = {};
					localStorage.setItem("viewedNotifications", JSON.stringify(viewedNotifications));
				}
			}
		},
		getDataLog(myLog) {
			this.session = myLog.sessionDate;
		}
	},
	mounted() {
		if (!localStorage.getItem("clienteAtual")) {
			this.hasData = false;
			return;
		}

		const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
		if (Object.keys(clienteAtual).length) {
			this.hasData = true;
			this.setClientData(clienteAtual);
		}
	}
}
</script>

<style scoped>
#spearhead {
	display: flex;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
	border-radius: 0px 0px 14px 14px;
	font-size: 11px;
	background-color: white;
	margin: 2px;
	box-shadow: -1px 5px 7px 0px #9f9999;
	transition: 0.7s;
	transition-timing-function: ease;
	height: max-content;
}

.spearhead-element {
	display: flex;
	flex-direction: column;
	text-align: center;
	border-right: 1px solid lightgray;
	border-left: 1px solid lightgray;
	padding: 0px 10px;
}

.spearhead-element span {
	font-size: 12px;
	text-align: center;
}

.center {

	display: flex;
	align-items: center;
	justify-content: center;
}

.reconnect-feedback {
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: gray;
	color: white;
}

.parte-cima {
	box-shadow: 5px 3px 6px -6px black;
	padding: 1px 5px 2px 20px;
	background-color: #ECF0F1;
	max-height: 10em;
	overflow-x: auto;
}

.row {
	margin-right: 0 !important;
}

::-webkit-scrollbar {
	width: 0.18rem;
}

::-webkit-scrollbar-track {
	background: #f38630;
}

::-webkit-scrollbar-thumb {
	background: #1c869a;
}

.espaco-lado-lado {
	max-width: 270px;
	width: 100%;
	margin: 0.1em 0 0.1em 0;
}

.img {
	height: 1.7em;
}

b {
	font-size: 1.1em;
	margin-left: 0.5em;
}

p {
	margin: 0 5px;
}

span {
	font-size: 20px;
}
</style>